var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsaxCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3497_312)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3497_312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3497_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 17.9014C20 18.2078 19.9319 18.5228 19.7872 18.8292C19.6425 19.1357 19.4552 19.4251 19.2083 19.6975C18.7912 20.1572 18.3315 20.4892 17.8122 20.7021C17.3015 20.9149 16.7481 21.0255 16.1522 21.0255C15.2839 21.0255 14.356 20.8212 13.3771 20.4041C12.3981 19.987 11.4191 19.4251 10.4487 18.7186C9.4697 18.0035 8.54181 17.2118 7.65648 16.335C6.77967 15.4497 5.98798 14.5218 5.28142 13.5513C4.58337 12.5809 4.02153 11.6104 3.61292 10.6485C3.20431 9.67802 3 8.75012 3 7.8648C3 7.28593 3.10215 6.7326 3.30646 6.22183C3.51077 5.70255 3.83425 5.22584 4.28543 4.8002C4.83025 4.2639 5.42614 4 6.05608 4C6.29444 4 6.5328 4.05108 6.74562 4.15323C6.96695 4.25538 7.16274 4.40861 7.31597 4.62994L9.29094 7.41362C9.44417 7.62644 9.55483 7.82223 9.63145 8.00951C9.70806 8.18828 9.75063 8.36705 9.75063 8.52879C9.75063 8.7331 9.69104 8.93741 9.57186 9.1332C9.46119 9.32899 9.29945 9.5333 9.09514 9.73761L8.44817 10.4101C8.35453 10.5038 8.31197 10.6144 8.31197 10.7506C8.31197 10.8187 8.32048 10.8783 8.33751 10.9464C8.36305 11.0145 8.38858 11.0656 8.40561 11.1167C8.55884 11.3976 8.82273 11.7636 9.1973 12.2063C9.58037 12.649 9.98898 13.1002 10.4316 13.5513C10.8913 14.0025 11.334 14.4196 11.7852 14.8027C12.2278 15.1773 12.5939 15.4326 12.8833 15.5859C12.9259 15.6029 12.977 15.6284 13.0366 15.654C13.1047 15.6795 13.1728 15.688 13.2494 15.688C13.3941 15.688 13.5048 15.637 13.5984 15.5433L14.2454 14.9049C14.4582 14.692 14.6625 14.5303 14.8583 14.4281C15.0541 14.309 15.2499 14.2494 15.4627 14.2494C15.6244 14.2494 15.7947 14.2834 15.982 14.36C16.1693 14.4367 16.365 14.5473 16.5779 14.692L19.3956 16.6925C19.6169 16.8458 19.7702 17.0245 19.8638 17.2374C19.9489 17.4502 20 17.663 20 17.9014Z",
    stroke: "white",
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3497_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsaxCall);
export default __webpack_public_path__ + "static/media/iconsax-call.ff4cec522691a96be05caef83b2b5fa7.svg";
export { ForwardRef as ReactComponent };